import React, { useState } from "react";
import { leadsAPI } from "../../services/api";
import "./Forms.css";

const CardForm = () => {
  const [formData, setFormData] = useState({
    firstName: "", lastName: "", email: "", phone: "",
    cardType: "", bank: "", annualIncome: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage("");
    try {
      await leadsAPI.submitCardApplication(formData);
      setSubmitMessage("success:Solicitud de tarjeta enviada. Pronto recibirá novedades.");
      setFormData({ firstName: "", lastName: "", email: "", phone: "", cardType: "", bank: "", annualIncome: "" });
    } catch (error) {
      setSubmitMessage("error:Error al enviar la solicitud. Intente de nuevo.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="form">
      <h3>Solicitud de Tarjeta de Crédito</h3>
      {submitMessage && (
        <div className={`message ${submitMessage.startsWith("success") ? "success" : "error"}`}>
          {submitMessage.split(":")[1]}
        </div>
      )}
      <div className="form-row">
        <div className="form-group"><label>Nombre *</label><input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required placeholder="Juan" /></div>
        <div className="form-group"><label>Apellido *</label><input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required placeholder="Pérez" /></div>
      </div>
      <div className="form-row">
        <div className="form-group"><label>Correo Electrónico *</label><input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="email@ejemplo.com" /></div>
        <div className="form-group"><label>Teléfono *</label><input type="tel" name="phone" value={formData.phone} onChange={handleChange} required placeholder="+598 99 123 456" /></div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label>Tipo de Tarjeta *</label>
          <select name="cardType" value={formData.cardType} onChange={handleChange} required>
            <option value="">Seleccione...</option>
            <option value="standard">Standard</option>
            <option value="gold">Gold</option>
            <option value="platinum">Platinum</option>
          </select>
        </div>
        <div className="form-group">
          <label>Banco Preferido *</label>
          <select name="bank" value={formData.bank} onChange={handleChange} required>
            <option value="">Seleccione...</option>
            <option value="anda">ANDA</option>
            <option value="itau">Itaú</option>
            <option value="santander">Santander</option>
            <option value="brou">BROU</option>
            <option value="passcard">Passcard</option>
          </select>
        </div>
      </div>
      <div className="form-group">
        <label>Ingreso Anual (USD) *</label>
        <input type="number" name="annualIncome" value={formData.annualIncome} onChange={handleChange} required min="0" placeholder="30000" />
      </div>
      <button type="submit" className="btn-submit" disabled={isSubmitting}>
        {isSubmitting ? "Enviando..." : "Solicitar Tarjeta"}
      </button>
    </form>
  );
};

export default CardForm;
